import QuillEventBus, { QuillEvents } from '@/components/texteditor/event-bus';
import config from '../config/advanced';

export default function anchorLinkHandler(v) {
  const range = this.quill.getSelection();
  // el cursor no está en el editor
  if (!range) {
    return;
  }

  const toolbar = this.quill.getModule('toolbar');
  const toolbarDom = toolbar.container;
  const bounds = toolbarDom.getBoundingClientRect();

  const dialogConfig = config.toolbar['ql-anchor-link'];

  const message = {
    uuid: this.quill.uuid,
    params: {
      dialogConfig,
      fields: {
        position: { x: bounds.x, y: bounds.top + bounds.height },
        creating: true,
        range,
      },
    },
  };

  QuillEventBus.$emit(QuillEvents.CREATE, message);
}
